export enum Funcionalidades {
  crear_expediente = 1,
  revisar_expediente = 2,
  revisar_solicitudes = 3,
  revisar_prorrogas = 4,
  revisar_expedientes_aprobados = 5,
  revisar_resoluciones_a_firmar = 6,
  revisar_expedientes_historial = 7,
  revisar_antecedentes = 8,
  revisar_apelaciones = 9,
  ver_plantillas = 10,
}

export default Funcionalidades;